// extracted by mini-css-extract-plugin
module.exports = {"artCircle":"artCircle_artCircle__E1Aru"};